import BaseSurveyAPI from '../s-base'

class MenuService extends BaseSurveyAPI {
  constructor() {
    super({ baseURL: `${process.env.VUE_APP_APIBASEURL}/api/v1` })
  }

  // 获取权限路由
  getRoutes(params) {
    return this.get({
      url: '/vocust-desk/menu/routes',
      params,
    })
  }
}

export default new MenuService()
